import { MyHttpClient } from '../../http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../../http-client.service";
var CustomerInvoiceReceiptRequestsService = /** @class */ (function () {
    function CustomerInvoiceReceiptRequestsService(http) {
        this.http = http;
        this.server = environment.server;
    }
    CustomerInvoiceReceiptRequestsService.prototype.raiseBulkInvoiceReceiptRequest = function (customerId, from, to, email) {
        var url = this.server + "/api/bulkInvoiceReceiptRequest/" + customerId;
        var body = { from: from, to: to };
        if (email)
            body.email = email;
        return this.http.post(url, body).pipe(catchError(this.handleError));
    };
    CustomerInvoiceReceiptRequestsService.prototype.handleError = function (error) {
        return throwError(error);
    };
    CustomerInvoiceReceiptRequestsService.ngInjectableDef = i0.defineInjectable({ factory: function CustomerInvoiceReceiptRequestsService_Factory() { return new CustomerInvoiceReceiptRequestsService(i0.inject(i1.MyHttpClient)); }, token: CustomerInvoiceReceiptRequestsService, providedIn: "root" });
    return CustomerInvoiceReceiptRequestsService;
}());
export { CustomerInvoiceReceiptRequestsService };
